export const LABELS_EXPORT = {
    closeExportMode: "Закрити режим еспорту",
    openExportMode: "Перейти в режим еспорту",
    exportPdf: "Експортувати в пдф форматі",
    exportExcel: "Експортувати в ексель форматі",
    exportStyles: "Налаштування вигляду експорту",
    excel: "Excel",
    pdfSettings: "Налаштуваня Excel",
    pdf: "Pdf",
    excelSettings: "Налаштуваня Pdf",
    thin: "Тонкий",
    medium: "Середній",
    thick: "Товстий",
    hair: "Хвилястий",
    paginationDisabledTooltip: "Щоб перейти на іншу сторінку дочекайтесь завершення завантаження",
    wrapText: "Переносити текст",
    dashed: "Штриховий",
    typeAlignment: "Положення",
    mediumDashed: "Штриховий збільшений",
    dashDot: "Тире Крапка",
    mediumDashDot: "Тире Крапка збільшений",
    dashDotDot: "Тире крапка крапка",
    mediumDashDotDot: "Тире крапка крапка збільшений",
    slantDashDot: "Нахил тире крапка",
    alignment: "Вирівнювання",
    topBorder: "Верхній",
    bottomBorder: "Нижній",
    leftBorder: "Лівий",
    rightBorder: "Правий",
    diagonalBorder: "Подіагоналі",
    border: 'Бордер',
    add: "Додати",
    update: "Оновити",
    font: "Шрифт",
    fill: "Заливка",
    typeBorder: "Тип бордеру",
    underline: "Підчеркнутий",
    hasFill: "Має заливку",
    patternTypeBg: "Тип заливки",
    addValue: "Додати значення",
    autoWidth: "к-сті символів назви колонки",
    color: "Колір",
    typeWidthColumn: "Тип ширини колонки",
    widthColumn: "Ширина колонки",
    widthColumnTooltip: "Ви можете встановити фіксовану кількість символів від якої буде залежити ширина колонки або ж від кількості символів в назві колонки",
    wch: "Ширина в символах",
    widthWch: "фіксована к-сть символів",
    oneValue: "Одне значення",
    vertical: 'Вертикальна',
    horizontalAlignment: 'Горизонтальне положення',
    verticalAlignment: 'Вертикальне положення',
    bottomAlignment: 'знизу',
    leftAlignment: 'З ліва',
    centerAlignment: 'По центру',
    rightAlignment: 'З права',
    justifyAlignment: 'По ширині',
    topAlignment: 'зверху',
    hasBackgroundText: 'Має заливку тексту',
    hasFillColor: 'Має заливку колонки',
    fontSize: "Розмір шрифту",
    outline: "контур",
    bold: "Жирний",
    shadow: "Тінь",
    pageOrientation: "Орієнтація сторінки",
    portrait: "Книжкова",
    landscape: "Альбомна",
    pageSize: "Розмір сторінки",
    italic: "Курсив",
    strike: "Перекресляний",
    colorText: 'Колір тексту',
    pdfBaseExportStyles: 'Загальні налаштування експорту PDF',
    exportStylesSettings: 'Загальні налаштування експорту',
    saveExportStylesMessage: 'Ви впевнені що хочете зберегти налаштування експорту?',

    exportLabels:{
        exportDataFromAllPage: 'Експортувати всі дані',
    }
}